import React, { useEffect,useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { Error, Success, Warning } from '../../../assets/images';
import { resetSession } from '../../../redux/auth';
import { useDispatch } from 'react-redux';

type AppProps = {
  isOpen: boolean;
  toggle?: any
  message?: string | null;
  onPress?: () => void;
  statusCode?: any;
  title: string;
  type?: string;
}

const RedirectErrorSuccessModal = ({
  isOpen,
  toggle,
  message,
  statusCode,
  title,
  onPress,
  type
}: AppProps) => {
  const dispatch = useDispatch();
const [seconds,setSeconds]=useState(4)
  const dispatchLogoutUser = () => {
    dispatch(resetSession());
  }

  useEffect(()=>{
    let interval:any=null;
    if(seconds===0){
      isOpen=false
      closeTab()
      return ()=>clearInterval(interval)
    }
    interval=setInterval(()=>{
      setSeconds(()=>seconds-1)
  },1000);
  return ()=>clearInterval(interval)
  })
  const closeTab = () => {
    isOpen=false
    window.opener = null;
    window.open("", "_self");
    window.close();
  };
  useEffect(()=>{
     if(seconds===0){
       localStorage.removeItem("isRedirected")
       localStorage.removeItem("redirectedToCustomerSupplier")
      closeTab()
     }
  },[seconds])

  return (
    <>
      <Modal
        centered
        isOpen={seconds!==0}
        toggle={toggle}
      >
        <ModalBody>
          <div className="d-flex justify-content-center align-items-center flex-column">
            <img src={type === "error" ? Error : type === 'warning' ? Warning : Success} className="mt-3" />
            <h3 className="mt-3">{title}</h3>
            <p className='text-center'>{message}</p>
            <p style={{fontWeight:'500'}}>This current browser tab will be close after <span className='text-danger' style={{textDecoration:'underline',textUnderlineOffset: "2px"}}>0{seconds} Sec.</span> ⏰</p>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default RedirectErrorSuccessModal